import { persons } from 'models/persons';

/**
 * Retrieves the positions array.
 * @returns {Array} The array of positions.
 */
export function getPositions() {
    return positions;
}

/**
 * Fetches data related to positions after waiting for persons data to load.
 * @returns {Promise<Array>} A promise that resolves to an array of position data.
 */
export function getPositionsData() {
    let data = []; // Initialize an empty array to hold position data
    return persons.waitData.then(() => {
        // Wait for persons data to be ready
        positions.map((pos) => {
            // Iterate over each position
            if (pos.id !== '$empty') {
                // Exclude the empty position
                let who = persons.find((pers) => pers.position === pos.id); // Find persons in the current position
                data.push({
                    // Push position data into the array
                    position: pos.value,
                    number: who.length, // Count of persons in the position
                    color: pos.color,
                });
            }
        });
        return data; // Return the populated data array
    });
}

/**
 * Array of position objects with their respective properties.
 * @type {Array<Object>}
 */
const positions = [
    { id: '$empty', value: '-- Not selected --', $empty: true },
    { id: '1', value: 'Sales manager', color: '#8664C6' },
    { id: '2', value: 'Customer service', color: '#1CA1C1' },
    { id: '3', value: 'General manager', color: '#F8643F' },
];

// FILE DOCUMENTED
